/**
 * Select a Job Priority.
 */

import {Select} from '@wandb/weave/components/Form/Select';
import {type IconName} from '@wandb/weave/components/Icon';
import React, {useMemo} from 'react';

import {PRIORITY_LEVEL, PRIORITY_LEVEL_METADATA} from './constants';
import * as S from './SelectComponents.styles';

export type PriorityOption = {
  value: PRIORITY_LEVEL;
  label: string;
  icon: IconName;
};

type SelectPriorityProps = {
  value?: PRIORITY_LEVEL;
  disabled?: boolean;
  onSelectPriority: (level: PRIORITY_LEVEL) => void;
};

const renderOptionLabel = (props: PriorityOption) => {
  const {label, icon} = props;

  return (
    <S.SelectOption>
      <S.SelectOptionIcon name={icon} />
      <S.SelectOptionLabel>{label}</S.SelectOptionLabel>
    </S.SelectOption>
  );
};

const options: PriorityOption[] = [
  PRIORITY_LEVEL.CRITICAL,
  PRIORITY_LEVEL.HIGH,
  PRIORITY_LEVEL.MEDIUM,
  PRIORITY_LEVEL.LOW,
].map(level => ({
  value: level,
  label: PRIORITY_LEVEL_METADATA[level].label,
  icon: PRIORITY_LEVEL_METADATA[level].icon,
}));

export const SelectPriority = ({
  value,
  disabled,
  onSelectPriority,
}: SelectPriorityProps) => {
  const onChange = (option: PriorityOption | null) => {
    if (option) {
      onSelectPriority(option.value);
    }
  };

  const optionValue = useMemo(
    () => options.find(option => option.value === value),
    [value]
  );

  return (
    <Select<PriorityOption, false>
      isDisabled={disabled}
      options={options}
      value={optionValue}
      onChange={onChange}
      formatOptionLabel={renderOptionLabel}
      placeholder="Select a priority level"
    />
  );
};
